import { render, staticRenderFns } from "./FacilityProfileTable.vue?vue&type=template&id=fee39984"
import script from "./FacilityProfileTable.vue?vue&type=script&lang=ts"
export * from "./FacilityProfileTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports